// components/pages/connection/Connecting.tsx

import React from "react"
import { Box, Container, Typography, Link, Avatar } from "@mui/material"
import PersonIcon from "@mui/icons-material/Person"
import { SigmaMainTitleBar } from "@shared/components/titlebar"
import { DeferredAnimatedBackground } from "@shared/components/background"
import { usePlatform } from "@core/hooks/usePlatform"

const Connecting = () => {
  const { isElectron } = usePlatform()

  return (
    <>
      {isElectron && <SigmaMainTitleBar />}
      <Box
        sx={{
          height: "100vh",
          paddingTop: isElectron ? "35px" : "env(safe-area-inset-top, 0px)",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <DeferredAnimatedBackground skipIntro />
        {/* 중앙 로그인 영역 */}
        <Container
          component="main"
          maxWidth="xs"
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minHeight: 0,
            position: "relative",
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              // 배경을 반투명으로 처리해 뒷 배경이 흐리게 보이도록 설정
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              backdropFilter: "blur(4px)",
              p: 4,
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            {/* 사용자 아이콘 */}
            <Avatar
              sx={{
                m: "0 auto",
                bgcolor: "primary.main",
                width: 56,
                height: 56,
              }}
            >
              <PersonIcon sx={{ fontSize: 40 }} />
            </Avatar>

            <Typography component="h1" variant="h5" sx={{ mt: 2 }}>
              서버 연결중
            </Typography>
          </Box>
        </Container>

        {/* 하단 링크 및 저작권 정보 */}
        <Box
          component="footer"
          sx={{
            textAlign: "center",
            p: 1,
            flexShrink: 0,
            position: "relative",
            zIndex: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Ninetynine Cloud Corp. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default Connecting
